import { render, staticRenderFns } from "./SwitcherBlock.vue?vue&type=template&id=fd39715e"
import script from "./SwitcherBlock.vue?vue&type=script&lang=js"
export * from "./SwitcherBlock.vue?vue&type=script&lang=js"
import style0 from "./SwitcherBlock.vue?vue&type=style&index=0&id=fd39715e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports